/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Story
 */
export interface Story {
    /**
     * 
     * @type {string}
     * @memberof Story
     */
    postId: string;
    /**
     * 
     * @type {string}
     * @memberof Story
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Story
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Story
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof Story
     */
    handleName: string;
}

/**
 * Check if a given object implements the Story interface.
 */
export function instanceOfStory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "postId" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "body" in value;
    isInstance = isInstance && "handleName" in value;

    return isInstance;
}

export function StoryFromJSON(json: any): Story {
    return StoryFromJSONTyped(json, false);
}

export function StoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Story {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'postId': json['postId'],
        'createdAt': json['createdAt'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'body': json['body'],
        'handleName': json['handleName'],
    };
}

export function StoryToJSON(value?: Story | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'postId': value.postId,
        'createdAt': value.createdAt,
        'title': value.title,
        'body': value.body,
        'handleName': value.handleName,
    };
}

